export default "__VITE_ASSET__SKugjImh__";